import UploadArea from '../../../../ui/upload-area';
import SupportingDocumentList from './supporting-document-list';
import { useDispatch, useSelector } from 'react-redux';
import { addFiles, selectIsDragging, setDragging } from '../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice';
import Label from '../../../../ui/label';
import { SupportingDocumentFile } from '../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.state';

interface Props {
    isPreview?: boolean;
    files: SupportingDocumentFile[];
    handleViewFile?: (filePath: string, fileName: string) => void;
    handleDownloadFile?: (filePath: string, fileName: string) => void;
}

export default function ClientSupportingDocuments({ isPreview = false, files, handleViewFile, handleDownloadFile }: Props) {

    const dispatch = useDispatch();

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = Array.from(e.target.files || []);
        dispatch(addFiles(selectedFiles));
        e.target.value = '';
    };

    const isDragging = useSelector(selectIsDragging);

    const handleDrop = (e: React.DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(setDragging(false));

        const items = Array.from(e.dataTransfer.items || []);
        const validFiles: File[] = [];

        items.forEach((item) => {
            if (item.kind !== "file") return;

            const entry = (item as any).webkitGetAsEntry?.();
            if (entry?.isDirectory) return;

            const file = item.getAsFile();
            if (file) validFiles.push(file);
        });

        if (validFiles.length > 0) {
            dispatch(addFiles(validFiles));
        }
    };

    return (
        <div className="w-full">
            {!isPreview && (
                <div className='flex flex-col gap-3 border-b border-[#186cb2]/20 bg-[#186cb2]/10 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4'>
                    <div className='space-y-1'>
                        <Label
                            label={"Attachment File"}
                            fontSize="text-xs"
                            fontWeight={`text-xs font-semibold text-gray-800`}
                        />
                        <p className="mt-1 text-[11px] leading-4 text-gray-500 sm:text-xs">
                            Enter the corresponding coverage amount for each designation.
                            You can add multiple rows as needed.
                        </p>
                    </div>
                    {files.length !== 0 && (
                        <label className="flex w-fit cursor-pointer items-center gap-2 rounded-lg bg-[#186cb2] px-3 py-2 text-xs font-medium text-white transition-colors hover:bg-[#155d99]">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <path d="M14 2v6h6" />
                                <path d="M12 18v-6" />
                                <path d="M9 15l3-3 3 3" />
                            </svg>
                            <span>Add File</span>
                            <input type="file" multiple className="hidden" onChange={handleFileChange} />
                        </label>
                    )}
                </div>
            )}
            {/* ================================================= */}
            {/* EMPTY PREVIEW */}
            {/* ================================================= */}
            {isPreview && files.length === 0 && (
                <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 px-4 py-6 text-center">
                    <p className="text-xs text-gray-500">
                        No supporting documents attached.
                    </p>
                </div>
            )}
            {/* ================================================= */}
            {/* UPLOAD AREA */}
            {/* ================================================= */}
            {!isPreview && (
                <div className='p-3'>
                    <UploadArea
                        length={files.length}
                        isDragging={isDragging}
                        onDragOver={(e) => {
                            e.preventDefault();
                            dispatch(setDragging(true));
                        }}
                        onDragLeave={(e) => {
                            e.preventDefault();
                            dispatch(setDragging(false));
                        }}
                        onDrop={handleDrop}
                        onFileChange={handleFileChange}
                    />
                </div>
            )}
            {/* ================================================= */}
            {/* FILE LIST */}
            {/* ================================================= */}
            <SupportingDocumentList
                files={files}
                isPreview={isPreview}
                handleDownloadFile={handleDownloadFile}
                handleViewFile={handleViewFile}
            />
        </div>
    );
}